import { DashboardState } from "../interfaces/dashboard"
import { Types } from "../types"
import { DashboardActions } from "../types/Dashboard/actionsType"




const initialState: DashboardState = {
    getLatestCallsPending: false,
    getLatestCallsError: null,
    latestCalls: []
}


const dashboardReducer = (state = initialState, action: DashboardActions, response: any) => {

    switch (action.type) {
        case Types.GET_LATEST_CALLS_REQUEST:
            return {
                ...state,
                getLatestCallsPending: true,
                getLatestCallsError: null,
                latestCalls: []
            }
        case Types.GET_LATEST_CALLS_SUCCESS:

            return {
                ...state,
                getLatestCallsPending: false,
                latestCalls: action.response
            }

        case Types.GET_LATEST_CALLS_ERROR:

            return {
                ...state,
                getLatestCallsPending: false,
                getLatestCallsError: action.payload
            }



        case Types.RESET_DASHBOARD_PROPS_REQUEST:
            return {
                ...state

            }

        default:
            return {
                ...state
            }
    }
}

export default dashboardReducer